import React, { useEffect, useState } from "react";
import "./ContactPage.css";
import { useLocation, useNavigate } from "react-router-dom";
import MessageUs from "../../comp/MessageUs/MessageUs";
import LandingPage from "../../comp/LandingPage/LandingPage";
import {
  ContactLanding,
  GlobalLogisticsDeliveryNetwork,
  Phone,
  Email,
} from "../../assests/images";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";

export default function ContactPage({ title }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  // State to track whether scrolling has occurred
  const [hasScrolled, setHasScrolled] = useState(false);
  useEffect(
    function () {
      document.title = title;
    },
    [title]
  );

  useEffect(() => {
    console.log(hasScrolled, state);
    if (!hasScrolled && state?.scrolling) {
      const scroll = state.scrolling;
      const servicesElement = document.getElementById(scroll);

      if (servicesElement) {
        // Scroll into view
        servicesElement.scrollIntoView({ behavior: "smooth" });
        setHasScrolled(true);
        navigate(location.pathname, { state: null, replace: true });
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state, hasScrolled, navigate]);

  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LdSFdgqAAAAAMpXz5R-XolRHvtRttVNa-F16Xra">
    <div className="contact__container">
      <LandingPage
        img={ContactLanding}
        subheading={`We're here to provide the support and information you need. Whether you have inquiries about our services, want assistance, or seek collaboration opportunities, reach out to us, and let's start a conversation. `}
        heading={"Have Questions? We're Here to Help, Contact Us Now!"}
        headingType={"text"}
        scroll={"contact"}
        buttonText={"Contact Us"}
      />

      <div className="conatact__companydetails">
        <div
          className="contact__companydetails__img" /* style={{backgroundColor:'var(--pastelOrange)'}} */
        >
          <img src={GlobalLogisticsDeliveryNetwork} alt="network" />
        </div>
        <div className="contact__companydetails__content">
          <p>OUR HEAD OFFICE</p>
          <p>In case of any requirement or query, Contact us...</p>
          <div className="contact__companydetails__detail">
            <div className="contactdetails__icons">
              <img src={Phone} alt="phone" /> <p>+91 70006 24695</p>
            </div>
            <div className="contactdetails__icons">
              <img src={Email} alt="email" /> <p>info@gravitinfosystems.com</p>
            </div>
          </div>
        </div>
      </div>
      <div id="contact" className="contact__form">
        <MessageUs />
      </div>
    </div>
    </GoogleReCaptchaProvider>
  );
}
